import { render, staticRenderFns } from "./LatestVehicles.vue?vue&type=template&id=3f18ba9c&"
import script from "./LatestVehicles.vue?vue&type=script&lang=js&"
export * from "./LatestVehicles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports